import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { KeyValue } from '@/main/models/common';

import { useTranslateHook } from '@/main/hooks/translateHook';
import { getStringStorage, LASTSYNCTRANSLATIONS, TRANSLATIONS } from '@/main/services/storage';
import { ApplicationState } from '@/main/store';
import { resetReducerTranslates, saveTranslates } from '@/main/store/translate';
import { getTranslateByKey, isEmpty } from '@/main/services/utils';

import * as S from './styles';

type TypeTranslates = 'en-US' | 'es-MX';

interface ITranslatesProps extends React.HTMLAttributes<HTMLDivElement> { }
function Translates(props: ITranslatesProps) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    isLoadingTranslates,
    translatesLocal: translatesLocalHook,
    getTranslates
  } = useTranslateHook({
    fillTranslateLocal: false
  });
  const translatesRedux = useSelector((state: ApplicationState) => state.translate);

  // check if exists in type, if not, set default en-us
  const INITIAL_CURRENT_TRANSLATE: TypeTranslates =
    (translatesRedux.translates.cultureUserLogged === 'en-US' || translatesRedux.translates.cultureUserLogged === 'es-MX')
      ? translatesRedux.translates.cultureUserLogged
      : 'en-US';

  const [currentTranslate, setCurrentTranslate] = useState<TypeTranslates>(INITIAL_CURRENT_TRANSLATE);

  async function loadTranslates(idCulture: string) {
    const lastSyncTranslations = getStringStorage(
      `${LASTSYNCTRANSLATIONS}_${idCulture}`
    );
    const responseApi = await getTranslates({
      culture: idCulture,
      lastSyncTranslations
    });
    if (responseApi.data.result) {
      // Save translates
      dispatch(
        saveTranslates(responseApi.data.result, idCulture, false, [])
      );
    }
  }

  function isTranslateNotFoundHomepage(dataTranslateStorage: string | null) {
    if (isEmpty(dataTranslateStorage)) return true;
    const jsonDataTranslateStorage = JSON.parse(dataTranslateStorage);
    const translateBase = getTranslateByKey('information.titleHomepage1', false, jsonDataTranslateStorage);

    return translateBase === 'Translate not found' || translateBase === 'Translates is empty'
  }

  async function changeTranslates(idTranslate: string) {
    const keyTranslateStorage = `${TRANSLATIONS}_${idTranslate}`
    const dataTranslateStorage = getStringStorage(keyTranslateStorage);
    const hasTranslateNotFound = isTranslateNotFoundHomepage(dataTranslateStorage);

    if (isEmpty(dataTranslateStorage) || hasTranslateNotFound) {
      await loadTranslates(idTranslate);
      return;
    }
    const serializedData = JSON.parse(dataTranslateStorage);
    navigate(location.pathname);
    dispatch(
      saveTranslates(serializedData, idTranslate, false, [])
    );
  }
  function toggleTranslate(translate: TypeTranslates) {
    setCurrentTranslate(translate);
    dispatch(resetReducerTranslates());
    changeTranslates(translate);

  }
  const TRANSLATES: KeyValue[] = [
    {
      key: 'en-US',
      value: 'EN'
    },
    {
      key: 'es-MX',
      value: 'ES'
    }
  ]

  return (
    <S.Container {...props}>
      {TRANSLATES.map((translate, index) => (
        <S.ButtonTranslate
          key={translate.key}
          $active={translate.key === currentTranslate}
          onClick={() => toggleTranslate(translate.key as TypeTranslates)}
        >
          {translate.value}
        </S.ButtonTranslate>
      ))}
    </S.Container>
  )
}

export default Translates